<template>
    <Dialog
        class="sazka-alert"
        v-model:visible="visible"
        modal
        :header="title"
        :draggable="false"
        :dismissableMask="true"
    >
        <div class="sazka-alert__wrapper">
            <div class="sazka-alert__subtext" v-html="subText"></div>
            <div class="sazka-alert__buttons">
                <Button v-if="linkText && link" component="a" :href="link">{{ linkText }}</Button>
                <Button expanded @click="visible = false">{{ btnCloseText }}</Button>
            </div>
            <div v-if="errorCode" class="sazka-alert__error-code">
                <span>{{ errorCode }}</span>
            </div>
        </div>
    </Dialog>
</template>
<script lang="ts" setup>
import { ref, watch, nextTick, getCurrentInstance } from "vue";
import Dialog from "primevue/dialog";
import type { SazkaAlert } from "@/shared/model/sazka-alert";
import Button from "@/shared/components/atoms/Button.vue";

withDefaults(defineProps<SazkaAlert>(), {
    btnCloseText: "OK",
});

const visible = ref(true);
const app = getCurrentInstance();

watch(visible, (newVal) => {
    if (!newVal) {
        nextTick(() => {
            app.appContext.app.unmount();
        });
    }
});
</script>
